import { Quiz as QuizUI } from "@business-finland/wif-ui-lib/dist/Quiz";
import { useRouter } from "next/router";

import { getAssetPath } from "src/util/magnolia";
import { formatPageLink } from "../../../util/magnolia";

export interface QuizProps {
  backgroundImage: Wif.Mgnl.Image;
  questions: Record<string, any>;
  ratings: Record<string, any>;
  shareDescriptionText: string;
  shareLink: any;
  linkOneText: string;
  linkTwoText: string;
  linkOneButtonText: string;
  linkTwoButtonText: string;
  linkOnePrimaryLink: any;
  linkTwoPrimaryLink: any;
}

export interface IQuizProps {
  question: string;
  options: string[];
  correctAnswer: string;
  tooltipText: string;
}

const extractPropsFromArray = (ValueObj: any, searchId: string, property: string): string[] => {
  return Object.keys(ValueObj)
    .filter((key) => key.includes(searchId))
    .map((key) => ValueObj[key][property] || "");
};

const getQuestionsArr = (ValueObj: any, searchId: string): IQuizProps[] => {
  return Object.keys(ValueObj)
    .filter((key) => key.includes(searchId))
    .map((key) => {
      return {
        question: ValueObj[key]?.question || "",
        options: extractPropsFromArray(ValueObj[key]?.answers, "answers", "answer"),
        correctAnswer: ValueObj[key]?.correctAnswer || "",
        tooltipText: ValueObj[key]?.popupText || "",
      };
    });
};

const getRatingsArr = (ValueObj: any, searchId: string): any[] => {
  return Object.keys(ValueObj)
    .filter((key) => key.includes(searchId))
    .map((key) => ({
      rating: ValueObj[key]?.rating || 0,
      ratingText: ValueObj[key]?.ratingText || "",
      ratingImage: getAssetPath(ValueObj[key]?.ratingImage) || "",
    }));
};

export function Quiz({
  backgroundImage,
  questions,
  ratings,
  shareDescriptionText,
  shareLink,
  linkOneText,
  linkTwoText,
  linkOneButtonText,
  linkTwoButtonText,
  linkOnePrimaryLink,
  linkTwoPrimaryLink,
}: QuizProps): JSX.Element {
  const questionsArr = getQuestionsArr(questions, "questions");
  const imageData = getAssetPath(backgroundImage);
  const ratingsArr = getRatingsArr(ratings, "ratings");
  const { locale } = useRouter();
  const formatLink = formatPageLink(shareLink);

  return (
    <div>
      <QuizUI
        backgroundImage={imageData}
        questions={questionsArr}
        ratingsArr={ratingsArr}
        shareLink={`${locale}${formatLink}`}
        shareDescriptionText={shareDescriptionText}
        linkOneText={linkOneText}
        linkTwoText={linkTwoText}
        linkOneButtonText={linkOneButtonText}
        linkTwoButtonText={linkTwoButtonText}
        linkOnePrimaryLink={linkOnePrimaryLink}
        linkTwoPrimaryLink={linkTwoPrimaryLink}
      />
    </div>
  );
}
